import { officialLog } from '@/api/util'
import {getItem,setItem,removeItem,get,set,remove} from '@/utils/storage'
// export async  function searchAll(title, page, pageSize) {
// 	let data ={
// 		title,
// 		page,
// 		pageSize
// 	}
//      var detail={}

// 	await officialLog(data).then(res=>{
// 		if (res.data.code === 200) {
// 			// showErrorTip(data.msg);
// 	       detail = res.data.data
// 		} else {
// 			this.$message.info(res.data.msg)
// 		}
// 	})
// 	return detail
// }

export function fff(i) {  
  let ff = [  
    { key: '/', value: '首页' },  
    { key: '/new', value: '培训平台1' },  
    { key: '/open', value: '培训平台2' },  
    { key: '/light', value: '教育行业解决方案' },  
    { key: '/projectA', value: '汽车行业解决方案' },  
    { key: '/projectB', value: '零售行业解决方案' },  
    { key: '/projectC', value: '金融行业解决方案' },  
    { key: '/projectD', value: '新能源行业解决方案' },  
    { key: '/projectE', value: '家电行业解决方案' },  
    { key: '/service', value: '大米课堂' },  
    { key: '/about', value: '关于我们公司简介' },  
    { key: '/about2', value: '关于我们大米资讯' },  
  ]  
  for (let g in ff) {  
    if (i == ff[g].key) {  
      return ff[g].value
    }  
  }  
}

export function report(j,i){
    var data1 = {
        uuid:getItem('result'),
        pageName:getItem('luyou'),
        duration:getItem('shijian'),
        toRegister:j,
        operateAnchor:i
    }
    officialLog(data1).then(res=>{
    })
  }